import React from 'react';
import PropTypes from 'prop-types';

import { converter } from '../../../../helpers/converter';

export default function TrailerButton({ visible, onPreview, translations }) {
  if (!visible) {
    return null;
  }

  return (
    <button className="btn btn-default btn-lg" onClick={onPreview}>
      <span className="text-inline">
        {converter.convertApaUnicode(translations, 'btn_trailer')}
      </span>
      <i className="fa fa-film icon-inline" />
    </button>
  );
}

TrailerButton.propTypes = {
  visible: PropTypes.bool,
  translations: PropTypes.object,
  onPreview: PropTypes.func,
};
